interface HeaderProps {
  connected: boolean;
  fuel: number;
  steel: number;
  ammo: number;
}

export default function Header({ connected, fuel, steel, ammo }: HeaderProps) {
  return (
    <header className="header">
      <div className="header-left">
        <h1 className="header-title">Massive Tanks</h1>
        <span className={`status-dot ${connected ? 'online' : 'offline'}`} />
        <span className="status-text">{connected ? 'Verbunden' : 'Getrennt'}</span>
      </div>
      <div className="header-resources">
        <div className="resource">
          <span className="resource-icon">⛽</span>
          <span className="resource-value">{fuel}</span>
        </div>
        <div className="resource">
          <span className="resource-icon">⛏️</span>
          <span className="resource-value">{steel}</span>
        </div>
        <div className="resource">
          <span className="resource-icon">💥</span>
          <span className="resource-value">{ammo}</span>
        </div>
      </div>
    </header>
  );
}
